import React from 'react';
import { Mail, MapPin, Send } from 'lucide-react';
import { motion } from 'framer-motion';
import { toast, Toaster } from 'react-hot-toast';

const Contact = () => {
  const handleSubmit = async (e) => {
    e.preventDefault();

    const form = e.target;
    const name = form.name.value;
    const email = form.email.value;
    const message = form.message.value;

    fetch('https://your-backend-url.com/send-email', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ name, email, message }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          toast.success('Message sent!');
          form.reset();
        } else {
          toast.error('Failed to send message.');
        }
      })
      .catch(() => {
        toast.error('An error occurred. Please try again later.');
      });
  };

  return (
    <section
      id="contact"
      className="relative py-24 px-6 bg-royalBlue text-white overflow-hidden"
    >
      <Toaster position="top-right" reverseOrder={false} />
      <div className="absolute inset-0 bg-pattern-overlay z-0" />

      <motion.div
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className="relative z-10 max-w-7xl mx-auto"
      >
        <h2 className="text-5xl font-extrabold text-center mb-6">Let’s Build Africa Together</h2>
        <p className="text-center max-w-2xl mx-auto text-lg text-gray-300 mb-16">
          Partner with Khalanga Global Ventures for your next logistics or infrastructure project.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-start">
          {/* Contact Form */}
          <motion.form
            onSubmit={handleSubmit}
            whileInView={{ opacity: 1, scale: 1 }}
            initial={{ opacity: 0, scale: 0.95 }}
            transition={{ duration: 0.6 }}
            className="bg-white/10 backdrop-blur-md p-8 rounded-2xl shadow-xl space-y-6"
          >
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <input
                type="text"
                name="name"
                placeholder="Your Name"
                required
                className="p-4 rounded-md bg-white text-black focus:outline-none"
              />
              <input
                type="email"
                name="email"
                placeholder="Your Email"
                required
                className="p-4 rounded-md bg-white text-black focus:outline-none"
              />
            </div>
            <textarea
              name="message"
              rows="6"
              placeholder="Your Message"
              required
              className="w-full p-4 rounded-md bg-white text-black focus:outline-none resize-none"
            />
            <button
              type="submit"
              className="flex items-center justify-center gap-2 bg-gold text-royalBlue font-bold py-3 px-6 rounded-full hover:brightness-110 transition"
            >
              <Send size={18} /> Send Message
            </button>
          </motion.form>

          {/* Contact Info & Map */}
          <motion.div
            whileInView={{ opacity: 1, x: 0 }}
            initial={{ opacity: 0, x: 50 }}
            transition={{ duration: 0.8 }}
            className="flex flex-col justify-center text-gray-200 space-y-6"
          >
            <div className="flex items-start gap-4">
              <MapPin className="text-gold w-6 h-6 mt-1" />
              <div>
                <p className="text-lg font-semibold text-white">Head Office</p>
                <p>90 Grayston Drive, Sandton, 2169</p>
              </div>
            </div>
            <div className="flex items-start gap-4">
              <Mail className="text-gold w-6 h-6 mt-1" />
              <div>
                <p className="text-lg font-semibold text-white">Email</p>
                <a
                  href="mailto:info@khalangaglobalventures.co.za"
                  className="hover:text-gold underline"
                >
                  info@khalangaglobalventures.co.za
                </a>
              </div>
            </div>

            {/* Live Google Map Embed */}
            <div className="overflow-hidden rounded-xl shadow-md border border-white/10">
              <iframe
                title="Khalanga Office Location"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3583.0549341536165!2d28.05506111552967!3d-26.106472181438537!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1e950dba86d90e3d%3A0xdccb98d4a6807a2!2s90%20Grayston%20Dr%2C%20Sandown%2C%20Sandton%2C%202196%2C%20South%20Africa!5e0!3m2!1sen!2sza!4v1716393607744!5m2!1sen!2sza"
                width="100%"
                height="250"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
          </motion.div>
        </div>
      </motion.div>
    </section>
  );
};

export default Contact;
